import type { JSX } from 'react';
import { Navigate, useParams } from 'react-router-dom';

export function DashboardUnitLegacyRedirect(): JSX.Element {
  const { propertyId, unitId } = useParams<{ propertyId: string; unitId: string }>();
  const normalizedPropertyId = (propertyId ?? '').trim();
  const normalizedUnitId = (unitId ?? '').trim();

  if (normalizedPropertyId.length === 0 || normalizedUnitId.length === 0) {
    return <Navigate to="/dashboard/properties" replace />;
  }

  return (
    <Navigate
      to={`/dashboard/properties/${normalizedPropertyId}/units/${normalizedUnitId}`}
      replace
    />
  );
}
